import * as React from 'react';
import { Layout as AntLayout } from 'antd';
import { useAppToken } from 'src/style';
import { Outlet } from 'react-router-dom';
import { Footer } from './footer';

const { Content } = AntLayout;

export const LayoutSlim = () => {
    const {
        token: { colorBgContainer }
    } = useAppToken();

    return <AntLayout>
        <Content className='site-layout' style={{ margin: '50px auto', maxWidth: 1080 }}>
            <div style={{ borderRadius: 8, padding: 24, background: colorBgContainer, height: '100%' }}>
                <Outlet />
            </div>
        </Content>
        <Footer />
    </AntLayout>;
};
